import { APP_NAME } from '@/config/productBrand';
import type { LoginBrand } from './useLoginForm';

/**
 * The left half of the Journey sign-in design: the world map, the brand, the headline, the destination
 * pins and the three things the ERP is for. Class names follow the supplied design; the styles are in
 * pages/auth/tripzaLogin.css. Hidden below 980px. Carries the company's logo and name on its own domain,
 * TravelERP's otherwise.
 */
export default function LoginHero({ brand = null }: { brand?: LoginBrand | null }) {
  const name = brand?.companyName ?? APP_NAME;

  return (
    <section className="scene">
      <div className="bg" />

      <div className="brand">
        {brand?.logoUrl && <img src={brand.logoUrl} alt={name} style={{ height: 36, background: '#fff', borderRadius: 6, padding: 3 }} />}
        <span className="wm">{name}</span>
        <span className="tag">Operations</span>
      </div>

      <div className="headline">
        <h1>One platform for every <span className="hl">journey</span> you create.</h1>
        <p>Departures, enquiries, bookings and travellers — managed from a single place.</p>
      </div>

      <div className="map" aria-hidden="true">
        <div className="pin" style={{ left: '5%', top: '78%' }}><span className="lbl">Jaisalmer</span><span className="dot" /></div>
        <div className="pin" style={{ left: '20%', top: '60%' }}><span className="lbl">Goa</span><span className="dot" /></div>
        <div className="pin" style={{ left: '36%', top: '66%' }}><span className="lbl">Spiti</span><span className="dot" /></div>
        <div className="pin" style={{ left: '50%', top: '40%' }}><span className="lbl">Ladakh</span><span className="dot" /></div>
      </div>

      <div className="pills">
        <div className="pill">
          <span className="ic">📅</span>
          <span><b>Departures</b><span>Fixed dates &amp; seats</span></span>
        </div>
        <div className="pill">
          <span className="ic">💬</span>
          <span><b>Enquiries</b><span>Every lead, tracked</span></span>
        </div>
        <div className="pill">
          <span className="ic">📊</span>
          <span><b>Analytics</b><span>Bookings &amp; revenue</span></span>
        </div>
      </div>
    </section>
  );
}
